import Vue from 'vue'
import ViewUI from 'view-design'
import app from './app.vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import plug from './plugins'
import stores from './store'
import routes from './routes'

import './assets/common/app.css'
import './assets/common/main.css'
import 'view-design/dist/styles/iview.css'

Vue.config.productionTip = true

Vue.use(ViewUI)
Vue.use(Vuex)
Vue.use(Router)
Vue.use(plug)

const store = new Vuex.Store(stores)

const router = new Router({
  routes
})
new Vue({
  router,
  store,
  render: h => h(app)
}).$mount('#container')
